(() => {
  const drawer = document.getElementById('vrCartDrawer');
  if (!drawer) return;
  const labels = JSON.parse(document.getElementById('vrCartTranslations').textContent);
  const items = document.getElementById('vrDrawerItems');
  const error = document.getElementById('vrDrawerError');
  const footer = document.getElementById('vrDrawerFooter');
  const root = drawer.dataset.root;
  const cartVariants = JSON.parse(document.getElementById('vrCartVariants').textContent) || [];
  const saleBanner = document.getElementById('vrCartSaleBanner');
  function updateSaleBanner() {
    const timerApi = window.VoltRidgeDailyTimer;
    const seconds = timerApi?.secondsUntilNextMidnight(saleBanner.dataset.timeZone || 'Australia/Brisbane');
    saleBanner.hidden = !Number.isFinite(seconds);
    document.getElementById('vrSaleClock').textContent = Number.isFinite(seconds) ? timerApi.format(seconds) : '--:--:--';
  }
  updateSaleBanner();
  setInterval(updateSaleBanner, 1000);
  document.addEventListener('visibilitychange', updateSaleBanner);
  let busy = false;
  let trigger = null;
  let previousOverflow = '';
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency }).format(amount / 100);
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  function setBusy(value) {
    busy = value;
    items.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-change],.vr-drawer-checkout').forEach(button => { button.disabled = value; });
  }
  function open() {
    if (drawer.open) return;
    trigger = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    drawer.showModal();
  }
  function close() { drawer.close(); }
  drawer.querySelector('.vr-drawer-close').onclick = close;
  drawer.querySelector('.vr-drawer-continue').onclick = close;
  drawer.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (trigger?.isConnected) trigger.focus();
  });
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const bounds = drawer.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right) close();
  });
  async function request(path, data) {
    const response = await fetch(root + path, {
      method: data ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(data ? { 'Content-Type': 'application/json' } : {}) },
      ...(data ? { body: JSON.stringify(data) } : {})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || labels.error);
    return result;
  }
  function render(cart) {
    items.replaceChildren();
    document.getElementById('vrDrawerCount').textContent = cart.item_count;
    const count = document.getElementById('cartCount');
    if (count) count.textContent = cart.item_count;
    footer.hidden = cart.item_count === 0;
    if (!cart.item_count) {
      const empty = node('div', 'vr-drawer-empty');
      empty.append(node('h3', '', labels.empty));
      const explore = node('button', 'vr-drawer-checkout', labels.explore);
      explore.type = 'button'; explore.onclick = close;
      empty.append(explore); items.append(empty); return;
    }
    for (const item of cart.items) {
      const line = node('article', 'vr-drawer-item');
      const image = node('img');
      image.src = item.handle === 'voltridge-cordless-pressure-washer' ? drawer.dataset.hero : item.image || drawer.dataset.hero;
      image.alt = item.product_title; image.width = 104; image.height = 104;
      const info = node('div', 'vr-drawer-info');
      const link = node('a', '', item.product_title); link.href = item.url;
      const title = node('h3'); title.append(link); info.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(node('p', 'vr-drawer-variant', item.variant_title));
      const price = node('div', 'vr-drawer-item-price');
      const variant = cartVariants.find(variant => Number(variant.id) === Number(item.variant_id));
      const compareTotal = Math.max(item.original_line_price, Number(variant?.compare_at_price || 0) * item.quantity);
      if (compareTotal > item.final_line_price) price.append(node('del', '', money(compareTotal, cart.currency)));
      price.append(node('strong', '', money(item.final_line_price, cart.currency)));
      if (compareTotal > item.final_line_price) {
        const percent = Math.round((compareTotal - item.final_line_price) / compareTotal * 100);
        price.append(node('span', 'vr-cart-discount', percent + '% ' + labels.off));
      }
      info.append(price);
      const actions = node('div', 'vr-drawer-actions');
      const qty = node('div', 'vr-drawer-quantity');
      for (const [text, next, label] of [['−', item.quantity - 1, labels.decrease], ['+', item.quantity + 1, labels.increase]]) {
        const button = node('button', '', text); button.type = 'button'; button.dataset.change = '';
        button.setAttribute('aria-label', label + ': ' + item.product_title); button.onclick = () => change(item.key, next);
        qty.append(button);
        if (text === '−') qty.append(node('span', '', item.quantity));
      }
      const remove = node('button', 'vr-drawer-remove', labels.remove); remove.type = 'button'; remove.dataset.change = ''; remove.onclick = () => change(item.key, 0);
      actions.append(qty, remove); info.append(actions); line.append(image, info); items.append(line);
    }
    document.getElementById('vrDrawerTotal').textContent = money(cart.total_price, cart.currency) + ' ' + cart.currency;
    document.getElementById('vrDrawerStatus').textContent = labels.updated;
  }
  function showError(caught) { error.textContent = caught.message || labels.error; error.hidden = false; }
  async function change(id, quantity) {
    if (busy) return;
    error.hidden = true; setBusy(true);
    try { render(await request('cart/change.js', { id, quantity })); }
    catch (caught) { showError(caught); }
    finally { setBusy(false); }
  }
  document.querySelectorAll('.cart-trigger').forEach(link => link.addEventListener('click', async event => {
    event.preventDefault(); if (busy) { open(); return; }
    open(); error.hidden = true; setBusy(true); items.textContent = labels.loading;
    try { render(await request('cart.js')); } catch (caught) { showError(caught); } finally { setBusy(false); }
  }));
  document.addEventListener('submit', async event => {
    if (event.target.id !== 'VoltRidgeProductForm') return;
    event.preventDefault(); if (busy) return;
    const data = new FormData(event.target);
    const buttons = document.querySelectorAll('#addToCart,#stickyAdd');
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    error.hidden = true; setBusy(true);
    try {
      await request('cart/add.js', { items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 }] });
      render(await request('cart.js')); open();
    } catch (caught) { open(); showError(caught); }
    finally { setBusy(false); buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); }); }
  });
})();
